import {OrderFormDesktop as BduiOrderForm} from '@yandex-delivery/order-form'
import React, {memo} from 'react'

import {appConfig, experiments} from 'src/shared/config'

import {OrderFormDeprecated} from './components/order-form-deprecated/OrderFormDeprecated@desktop'

export const OrderForm = memo(function OrderForm(): React.ReactElement {
  return experiments?.isBduiEnabled ? <BduiOrderForm config={appConfig} /> : <OrderFormDeprecated />
})
